import http from "./apiServices"

export const getSettingsById = (settingId) => {
  return http.get(`settings/${settingId}`)
}

export const putSettingsById = ({ settingId, settingInfo }) => {
  return http.put(`settings/${settingId}`, settingInfo)
}
